import React, { Component } from 'react';
import { func, arrayOf } from 'prop-types';
import numeral from 'numeral';
import { reducerAccumulator } from '@widergy/web-utils/lib/array';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import NormalDetail from '../AccountStatus/components/AccountSelector/components/AccountDetails/components/NormalDetail';
import { accountPropTypes } from '../../../../../redux/accountHandlers';
import UTTable from '../../../../components/UTTable';
import UTTag from '../../../../components/UTTag';
import UTMobileTable from '../../../../components/UTMobileTable';
import UTTouchableWithoutFeedback from '../../../../components/UTTouchableWithoutFeedback';
import { DefaultViewport, MobileViewport } from '../../../../../constants/deviceSizes';
import PaymentsHeader from '../Payments/components/PaymentsHeader';
import { CLIENT_SUMMARY } from '../../../../../constants/common';
import { message } from '../../../../../utils/stringUtils';
import Images from '../../../../../config/assets';
import { appConfig } from '../../../../../config/customization';

import styles from './styles';

class ClientSummaryScene extends Component {
  columns = [
    {
      key: 'address',
      name: message('Commons:address').toUpperCase(),
      width: 0.36
    },
    {
      key: 'client_number',
      name: message('ClientSummary:nis').toUpperCase(),
      width: 0.1
    },
    {
      key: 'rate',
      name: message('ClientSummary:rate').toUpperCase(),
      width: 0.2
    },
    {
      key: 'status',
      name: message('ClientSummary:status').toUpperCase(),
      width: 0.1,
      cellRenderer: ({ cellData }) => cellData && <UTTag>{cellData}</UTTag>
    },
    {
      key: 'balance',
      name: message('ClientSummary:balance').toUpperCase(),
      width: 0.11,
      cellRenderer: ({ cellData, rowData }) => {
        const alt = message('ClientSummary:arrow');
        return [
          numeral(cellData).format('$0,0.[00]'),
          <UTTouchableWithoutFeedback
            key={`${alt}-button`}
            onClick={() => this.props.handleSelectAccount(rowData.client_number)}
          >
            <img alt={alt} src={Images.listArrowUp} style={styles.arrow} />
          </UTTouchableWithoutFeedback>
        ];
      }
    }
  ];

  mobileColumns = account => [
    {
      value: account.address,
      field: message('Commons:address').toUpperCase(),
      fieldRenderer: 'TextField'
    },
    {
      value: account.client_number,
      field: message('ClientSummary:nis').toUpperCase(),
      fieldRenderer: 'TextField'
    },
    {
      fieldRenderer: (
        <div style={styles.mobileTypeContainer}>
          <UTLabel bold small>
            {message('Commons:type').toUpperCase()}
          </UTLabel>
          <NormalDetail value={account.rate} status={account.status} style={styles.normalDetail} />
        </div>
      )
    },
    {
      value: numeral(account.balance).format('$0,0.[00]'),
      field: message('ClientSummary:balance').toUpperCase(),
      fieldRenderer: 'TextField'
    }
  ];

  retrieveTotalAmount = () => this.props.accounts.map(item => item.balance).reduce(reducerAccumulator, 0);

  columnsWithoutStatus = () => this.columns.filter(column => column.key !== 'status');

  render() {
    return (
      <div style={styles.container}>
        <PaymentsHeader
          totalAmount={this.retrieveTotalAmount()}
          secondaryTopbarText={message('ClientSummary:secondaryTopbarText')}
          totalAmountText={message('ClientSummary:totalAmountText')}
          handlePayment={this.props.handlePayment}
          handlePressPaymentButton={this.props.handlePressPaymentButton}
          handleExternalAccPayment={this.props.handleExternalAccPayment}
        />

        <div style={styles.table}>
          <DefaultViewport>
            <UTTable
              columns={appConfig.clientSummary.useStatusColumn ? this.columns : this.columnsWithoutStatus()}
              rows={this.props.accounts}
              id={CLIENT_SUMMARY}
              scrolleable
              heightToSubstract={60}
            />
          </DefaultViewport>
          <MobileViewport>
            <UTMobileTable tables={this.props.accounts} rowRenderer={this.mobileColumns} />
          </MobileViewport>
        </div>
      </div>
    );
  }
}

ClientSummaryScene.propTypes = {
  accounts: arrayOf(accountPropTypes),
  handleSelectAccount: func.isRequired,
  handlePayment: func.isRequired,
  handlePressPaymentButton: func.isRequired,
  handleExternalAccPayment: func.isRequired
};

export default WithLoading(props => props.loading)(ClientSummaryScene);
